import { create } from 'zustand'

import { NomenclaturePreviewDataColumnMappingBySheet } from '@/types'

interface ExcelFileUploaderStateInterface {
  previewDataColumnMapping: NomenclaturePreviewDataColumnMappingBySheet
  currentIncludedSheet: string
  setPreviewDataColumnMapping: (
    previewDataColumnMappingProto: NomenclaturePreviewDataColumnMappingBySheet,
    key?: string,
    value?: number,
    sheet?: string
  ) => void
  setCurrentIncludedSheet: (currentIncludedSheet: string) => void
  setInitialExcelFileUploaderStore: () => void
}

const initialState = {
  previewDataColumnMapping: {},
  currentIncludedSheet: '',
}

export const useExcelFileUploaderStore =
  create<ExcelFileUploaderStateInterface>((set, get) => ({
    ...initialState,
    setPreviewDataColumnMapping: (
      previewDataColumnMappingProto: NomenclaturePreviewDataColumnMappingBySheet,
      key: string = '',
      value: number = -1,
      sheet: string = ''
    ) => {
      if (Object.keys(previewDataColumnMappingProto).length) {
        set({ previewDataColumnMapping: previewDataColumnMappingProto })
        return
      }
      const previousPreviewDataColumnMapping = get().previewDataColumnMapping
      const sheetMapping = previousPreviewDataColumnMapping[sheet] as Record<
        string,
        number
      >

      let changeProp = ''
      let resetProp = ''
      Object.entries(sheetMapping).forEach(([propKey, propValue]) => {
        if (propValue === value && key) {
          changeProp = propKey
        }
        if (propValue === value && !key) {
          resetProp = propKey
        }
      })
      set({
        previewDataColumnMapping: {
          ...previousPreviewDataColumnMapping,
          [sheet]: {
            ...previousPreviewDataColumnMapping[sheet],
            ...(key && changeProp && { [changeProp]: -1 }),
            ...(!key && resetProp && { [resetProp]: -1 }),
            ...(key && { [key]: value }),
          },
        },
      })
    },
    setCurrentIncludedSheet: (currentIncludedSheet: string) => {
      set({
        currentIncludedSheet,
      })
    },
    setInitialExcelFileUploaderStore: () => set({ ...initialState }),
  }))
